<template >
    <div class="update-contract-dialog">
        <el-dialog :visible.sync="visible" :title="$t('Contract.up')" left >
            <div class="msph-dialog-title bg-gray mg-10">
                <p class="msph-dialog-title-p">
                    <span class="update-title-span">
                        {{ $t('Common.name') }}：{{ contractInfo.clientName }}
                    </span>
                    <span class="update-title-span1">
                        {{ $t('Common.phone') }}：{{ contractInfo.clientPhone }}
                    </span>
                </p>
                <p class="msph-dialog-title-p">
                    <span class="update-title-span">
                        {{ $t('Contract.number') }}：{{ contractInfo.contractNum }}
                    </span>
                    <span class="update-title-span1">
                        {{ $t('Contract.card_name') }}：{{ contractInfo.cardName }}
                    </span>
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Contract.support_store') }}：{{ contractInfo.supportStoreNames }}
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Common.card_number') }}：{{ contractInfo.cardNum }}
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Contract.start_end_date') }}：{{ contractInfo.validityPeriod }}
                </p>
                <p class="msph-dialog-title-p">
                    <span class="update-title-span ">
                        {{ $t('Sell.standard_amount') }}：{{ contractInfo.baseAmtStr}}
                    </span>
                    <span class="update-title-span1 ">
                        {{ $t('Member.saler') }}：{{ contractInfo.contractSalesStaffNickname }}
                    </span>
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Sell.Charge.paid_amount') }}：{{contractInfo.paidAmtStr}}
                </p>
            </div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="120px"
                label-suffix=":">
                <el-form-item :label="$t('Member.sign_store')" prop="storeId" >
                    <el-select
                        v-model="form.storeId"
                        @change="fetchSelect"
                        :placeholder="$t('Common.all_store2')"
                        class="w-full" clearable>
                        <el-option
                            v-for="(item, index) in stores"
                            :key="index"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Member.saler')" prop="salesStaffId">
                    <el-select
                        v-model.number="form.salesStaffId"
                        :placeholder="$t('Common.please_choose')"
                        @change="searchText === null"
                        class="w-full" clearable>
                        <input type="text" class="search-input-all" v-model="searchText"/>
                        <el-option
                            v-for="(item, index) in filterList"
                            :key="index"
                            :label="item.nickname"
                            :disabled="item.id === 'no'"
                            :value="Number(item.id)"/>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Contract.card_name')" prop="cardId">
                    <el-select
                        v-model="form.cardId"
                        :placeholder="$t('Common.please_choose')"
                        v-on:change="fetchCardInfo">
                        <el-option
                            v-for="(item, index) in cards"
                            :key="index"
                            :label="item.name"
                            :value="Number(item.id)"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item
                    prop="supportStoreType"
                    :label="$t('Contract.support_store')"
                    v-if="cardInfo.supportStoreType">
                    {{cardInfo.supportStoreType === 1 ? $t('Staff.single_store')
                    : cardInfo.supportStoreType === 2 ? $t('Staff.tong_store')
                    : $t('Staff.all_store')}}
                </el-form-item>
                <div v-if="cardInfo.supportStoreType === 2" class="box-1e">
                    <div>
                        <el-checkbox
                            class="label-name"
                            :indeterminate="isSupportIndeterminate"
                            v-model="checkAll"
                            @change="handleCheckAllChange"
                        >{{ $t('Course.check_all') }}</el-checkbox>
                        <div class="box-a">
                            <el-checkbox-group
                                v-model="form.supportStoreIds"
                                @change="handleCheckedSupportStoresChange">
                                <el-checkbox
                                    v-for="(item, index) in stores"
                                    :label="item.id"
                                    :key="index"
                                >{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
                <el-form-item prop="activeCardWayCode" :label="$t('Member.open_card_method')">
                    <el-select
                        :disabled="true"
                        v-model="form.activeCardWayCode"
                        :placeholder="$t('Member.open_card_placeholder')"
                        class="w-full"
                        clearable>
                        <el-option :label="$t('Card.Way.day')" :value="1"/>
                        <el-option :label="$t('Card.Way.date')" :value="3"/>
                    </el-select>
                </el-form-item>
                <el-form-item
                    prop="daysToActive"
                    v-if="cardInfo.giftCredit">
                    <div v-if="cardInfo.giftCredit" class="mb-2">
                        <span style="font-size: 12px">{{ $t('Card.gift_day2') }}: </span>
                        <el-input
                            type="number"
                            style="width: 50px;"
                            v-model="form.giftCredit"
                            :max="cardInfo.giftCredit"
                            min="0"
                        />
                        <span style="font-size: 12px">
                             ≤ {{cardInfo.giftCredit}} {{ $t('Week.day2') }}
                        </span>
                    </div>
                </el-form-item>
                <el-form-item
                    :label="$t('Contract.start_time')"
                    v-if="form.activeCardWayCode === 3"
                    prop="startAt">
                    <el-date-picker
                        @change="addDate"
                        v-model="form.startAt"
                        type="date"
                        style="width:180px"
                        :placeholder="$t('Reception.Third.time_placeholder')"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <p v-if="contractEndAt" style="font-size:12px;margin: -10px 0 15px 120px">
                    {{ $t('Contract.end_time') }}:{{contractEndAt}}
                </p>
                <el-form-item prop="contractNum" :label="$t('Contract.number')">
                    <el-input
                        type="text"
                        v-model="form.contractNum"
                        :placeholder="$t('Contract.fill_number')"
                        style="width:200px" class="mr-2"
                    />
                    <el-button
                        type="success"
                        v-if="autoContractNum"
                        @click="getAutoContractNum"
                    >{{ $t('Common.zidong') }}</el-button>
                </el-form-item>
                <el-form-item prop="remark" :label="$t('Common.remark')">
                    <el-input type="textarea" v-model="form.remark"/>
                </el-form-item>
                <div style="border-top:1px solid #ccc; margin: 20px 0px 20px 0px;"></div>
                <el-form-item prop="baseAmt" :label="$t('Charge.amount_receivable')" >
                    <el-input
                        type="number"
                        style="width: 150px"
                        v-model="form.baseAmt"
                        :placeholder="$t('Fill.amount_receivable')"
                    />
                    <p class="msph-dialog-title-p">{{ $t('Fill.amount_tips') }}</p>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button @click="submit" type="primary">{{ $t('Common.next_step') }}</el-button>
            </div>
        </el-dialog>
        <pay-form ref="pay" :contract="'upgrade'" @refreshData="refreshData"/>
    </div>
</template>

<script>

import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    CheckboxGroup,
    CheckboxButton,
    TimePicker,
    Row,
} from 'element-ui';
import PayForm from '@/components/Dialog/Client/PayForm';
import filterRole from '@/mixins/filterRole.js';

export default {
    props: ['stores', 'activeName'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckboxButton: CheckboxButton,
        ElTimePicker: TimePicker,
        ElRow: Row,
        PayForm,
    },
    mixins: [filterRole],
    data() {
        return {
            contractEndAt: '',
            autoContractNum: false,
            checkAll: false,
            isSupportIndeterminate: false,
            cardInfo: {},
            searchText: '',
            contractInfo: {},
            staffs: [],
            cards: [],
            loading: false,
            visible: false,
            form: {
                storeId: 0,
                supportStoreIds: [],
                salesStaffId: 0,
                startAt: '',
                contractNum: '',
                supportStoreType: 0,
                cardId: 0,
                activeCardWayCode: 0,
            },
            rules: {
                storeId: {
                    required: true, message: this.$t('Common.store_placeholder'), type: 'number',
                },
                supportStoreIds: {
                    required: true,
                    message: this.$t('Choose.support_store'),
                    trigger: 'blur',
                },
                salesStaffId: {
                    required: true,
                    message: this.$t('Choose.saler2'),
                    type: 'number',
                },
                startAt: { required: true, message: this.$t('Contract.start_date'), trigger: 'blur' },
                contractNum: { required: true, message: this.$t('Contract.fill_number') },
                supportStoreType: { required: true, message: this.$t('Choose.support_store') },
                cardId: { required: true, message: this.$t('Choose.card_zhong'), type: 'number' },
                activeCardWayCode: {
                    required: true,
                    message: this.$t('Member.open_card_placeholder'),
                },
            },
        };
    },
    watch: {},
    computed: {
        filterList() {
            if (!this.searchText) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        refreshData() {
            this.$emit('refreshData');
        },
        resetForm() {
            this.form = {
                storeId: '',
                supportStoreIds: [],
                salesStaffId: '',
                startAt: '',
                contractNum: '',
                supportStoreType: '',
                cardId: '',
                activeCardWayCode: '',
            };
        },
        open(data) {
            // data 代表合同信息
            this.resetForm();
            this.visible = true;
            if (data) {
                this.contractInfo = data;
                this.fetchContract();
            }
        },
        fetchContract() {
            API.get(`contract/mshp/${this.contractInfo.contractNum}`)
                .then(res => {
                    this.contractInfo = res;
                    this.fetchSalers();
                    this.visible = true;
                });
        },
        fetchSelect() {
            this.stores.forEach(el => {
                if (el.id === this.form.storeId) {
                    this.autoContractNum = el.autoContractNum;
                }
            });

            this.$set(this.form, 'baseAmt', null);
            this.$set(this.form, 'salesStaffId', null);
            this.$set(this.form, 'cardId', null);
            this.fetchSalers();
            this.fetchCard();
        },
        async fetchSalers() {
            this.loading = true;
            const ids = [5, 6];
            const storeId = this.form.storeId;
            this.staffs = await this.filterRole(null, ids, storeId);
            this.loading = false;
        },
        fetchCardInfo(val) {
            this.loading = true;
            API.get(`member-card/${val}/card-info`).then(res => {
                this.cardInfo = res;
                this.form.supportStoreType = res.supportStoreType;
                this.form.baseAmt = res.basePrice;
                this.$set(this.form, 'activeCardWayCode', 3);
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchCard() {
            this.loading = true;
            API.get(`member-card/list?storeId=${this.form.storeId}`).then(res => {
                this.cards = res;
                if (this.cards.length < 1) {
                    this.cardInfo = {};
                    this.form.supportStoreType = '';
                    this.form.baseAmt = '';
                    this.form.cardId = '';
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        postData() {
            this.form.clientId = this.contractInfo.clientId;
            API.post(`contract/mshp/${this.contractInfo.contractNum}/upgrade`, this.form)
            .then(() => {
                this.$refs.pay.open(this.form.contractNum);
                this.resetForm();
                this.visible = false;
            })
            .finally(() => {
                this.loading = false;
            })
            .catch(err => {
                $ele.$message.error(err);
            });
        },
        handleCheckAllChange(val) {
            this.form.supportStoreIds = val ? this.stores.map(el => el.id) : [];
            this.isSupportIndeterminate = false;
        },
        handleCheckedSupportStoresChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.stores.length;
            this.isSupportIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
        },
        getAutoContractNum() {
            this.loading = true;
            API.get(`store/${this.form.storeId}/gen-contract-num`).then(res => {
                this.$set(this.form, 'contractNum', res);
            }).finally(() => {
                this.loading = false;
            });
        },
        addDate(val) {
            const date = new Date(val);
            date.setDate(date.getDate() + this.cardInfo.validPeriod);
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            this.contractEndAt = `${year}-${month}-${day}`;
        },
    },
};
</script>

<style lang="scss">
.update-contract-dialog {
    .el-dialog {
        width: 550px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow-y: auto;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .el-dialog__body {
        min-width: 35%;
        height: 78vh;
        overflow: auto;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .el-checkbox {
        margin-right: 20px;
        margin-left: 0px;
    }
    .msph-dialog-title {
        border: 1px solid #e6e6e6;
        padding-left: 10px;
        background: #f7f7f7 !important;
        margin-bottom: 15px;
        padding: 6px 14px;
    }
    .msph-dialog-title-p {
        width: 100% !important;
        font-size: 12px;
        margin: 10px 0;
    }
    .box-1e {
        position: relative;
        left: 120px;
        margin-bottom: 15px!important;
        padding: 15px 15px 0 15px;
        background: #eee;
        width: 75%;
        min-height: 150px;
    }
    .box-a {
        margin-left: 20px;
        padding: 10px 15px;
        background: #fff!important;
        min-height: 70px!important;
        overflow: scroll;
    }
    .contract_card_show {
        display: block;
        overflow: hidden;
        width: 160px;
        height: 100px;
        border-radius: 5px;
    }
    .update-title-span {
        display: inline-block;
        font-size: 12px;
        width: 40%;
    }
    .update-title-span1 {
        display: inline-block;
        width: 50%;
        font-size: 12px;
    }
}
</style>
